import React, { useEffect, useRef } from "react";
import Map from "../../components/map";
import Header from "../../components/header";
import { getGeoJSON, getRegionContent } from "../../actions/data";
import { selectMapType, selectGeoJSON } from "../../reducers/";
import styles from "./root.module.scss";
import { connect } from "react-redux";
import ErrorBoundary from "./error-boundary";
import Loading from "../../components/loading";
import Sidebar from "../../components/sidebar";
import PropTypes from "prop-types";
import geometryConfigs from "../../modules/geometryConfigs";
import useComponentSize from "@rehooks/component-size";

const Root = (props) => {
  const { mapType, getRegionContent, getGeoJSON, geojson } = props;
  const ref = useRef();
  const size = useComponentSize(ref);
  useEffect(() => {
    getGeoJSON(
      geometryConfigs[mapType].geojsonUrl,
      geometryConfigs[mapType].topologyObjectsName
    );
    getRegionContent();
  }, []);
  if (!geojson)
    return (
      <div
        data-container
        ref={ref}
        id="SMU_ROOT"
        className={styles.container}
      />
    );

  return (
    <ErrorBoundary>
      <div data-container id="SMU_ROOT" className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.app} ref={ref}>
            {size.height === 0 ? (
              <Loading />
            ) : (
              <React.Fragment>
                <Header
                  geometryConfig={geometryConfigs[mapType]}
                  nameSelector={geometryConfigs[mapType].nameSelector}
                />
                <Sidebar />
                <Map
                  width={size.width}
                  height={size.height}
                  geometryConfig={geometryConfigs[mapType]}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};
const mapStateToProps = (state) => ({
  mapType: selectMapType(state),
  geojson: selectGeoJSON(state),
});

Root.propTypes = {
  getRegionContent: PropTypes.func.isRequired,
  getGeoJSON: PropTypes.func.isRequired,
  mapType: PropTypes.string.isRequired,
  geojson: PropTypes.object,
};
const mapDispatchToProps = { getRegionContent, getGeoJSON };
export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js